var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _ellipse, _ellipse2, _circle2, _circle3, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#5f8f8b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#78a8a3",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 124C14 100 36 92 60 92S106 100 106 124Z",
    fill: "#33485c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 92L60 106L72 92Z",
    fill: "#fbf1e2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14L52 36L30 52Z",
    fill: "#e8782f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14L68 36L90 52Z",
    fill: "#e8782f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24L46 36L34 44Z",
    fill: "#b8541a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24L74 36L86 44Z",
    fill: "#b8541a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56C26 38 42 32 60 32S94 38 94 56C94 74 76 92 60 94C44 92 26 74 26 56Z",
    fill: "#e8782f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60C34 62 44 70 52 80C56 84 64 84 68 80C76 70 86 62 94 60C92 76 76 94 60 96C44 94 28 76 26 60Z",
    fill: "#fbf1e2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74L64 74L60 79Z",
    fill: "#2a1d1a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79Q60 84 55 84M60 79Q60 84 65 84",
    stroke: "#2a1d1a",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 58,
    rx: 3,
    ry: 4,
    fill: "#2a1d1a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72,
    cy: 58,
    rx: 3,
    ry: 4,
    fill: "#2a1d1a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 56.5,
    r: 1,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 56.5,
    r: 1,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48L52 51M78 48L68 51",
    stroke: "#b8541a",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait18);
export default __webpack_public_path__ + "static/media/player-portrait-18.0e0cf44bed49230008955fc45b5735dc.svg";
export { ForwardRef as ReactComponent };